import { css } from "@emotion/react";
import { theme } from "@minted/minted-components";

/**
 * Typography reset to undo the site's FancyClothes/theme overrides (font-family,
 * letter-spacing, line-height, color, text-transform) so content renders with
 * design-system defaults. Spread into the relevant wrapper at call sites (modals,
 * cards, RSVP forms, etc.).
 *
 * Use `text-transform: none` here, not `unset`: `text-transform` is inherited, and
 * `unset` on inherited properties behaves like `inherit`, so the body theme would still apply.
 *
 * FancyClothes injects `body { font-family: <theme-font> }` globally; explicitly
 * setting font-family here ensures product chrome uses the design-system font
 * regardless of injection order.
 */
export const themeTypographyResetStyles = css`
  color: ${theme.colors.textPrimary};
  font-family: "Gotham", "Helvetica", "Arial", sans-serif;
  letter-spacing: normal;
  line-height: normal;
  text-transform: none;
`;
